import { graphql } from '@gql';

export const GET_MITIGATIONS_FOR_COMPONENT = graphql(`
    query GetMitigationsForComponent(
        $first: Int
        $after: Cursor
        $where: MitigationWhereInput
    ) {
        mitigations(first: $first, after: $after, where: $where) {
            pageInfo {
                endCursor
                hasNextPage
            }
            edges {
                node {
                    componentNotification {
                        id
                        notification {
                            id
                        }
                    }
                }
            }
        }
    }
`);

export const GET_SECURITY_NOTIFICATION = graphql(`
    query GetSecurityNotification($id: ID!) {
        notifications(where: { id: $id }) {
            edges {
                node {
                    ...NotificationFragment
                }
            }
        }
    }
`);

export const GET_SECURITY_NOTIFICATIONS_FOR_COMPONENT = graphql(`
    query GetSecurityNotificationForComponent($id: ID!) {
        notifications(where: { hasComponentsWith: { id: $id } }) {
            edges {
                node {
                    ...NotificationFragment
                }
            }
        }
    }
`);

export const GET_SECURITY_NOTIFICATIONS_SERVER_DETAILS = graphql(`
    query GetSecurityNotificationsServerDetails($notificationID: ID!) {
        notifications(where: { id: $notificationID }) {
            edges {
                node {
                    id
                    title
                    publishDate
                    lastUpdateDate
                    impact
                    source
                    cves {
                        id
                        code
                        description
                        weakness
                        publishDate
                        lastUpdateDate
                        cvssVector
                        cvssBaseScore
                        source
                    }
                    cvssVector
                    cvssOverrideVector
                    solutionStatus
                    action
                    solutionDetails
                    references
                    legalNotice
                    vendorAdvisories {
                        name
                    }
                    components {
                        id
                        name
                        cpeName
                        version
                        eolReached
                        eolDate
                        monitoredSince
                        componentVendor {
                            id
                            name
                            ifa
                            description
                        }
                    }
                }
            }
        }
    }
`);

export const GET_COMPONENT_NOTIFICATIONS_FOR_PROJECT_SERVER = graphql(`
    extend type ProjectComponentNotification
        @typePolicy(keyFields: "assetItemID notificationID componentID")
    query getProjectComponentsNotificationsServer(
        $pid: ID!
        $first: Int
        $where: ProjectComponentNotificationWhereInput
        $orderBy: ProjectComponentNotificationOrder
    ) {
        projectComponentsNotifications(
            projectID: $pid
            where: $where
            orderBy: $orderBy
            first: $first
        ) {
            edges {
                node {
                    id
                    notificationID
                    assetItemID
                    componentID
                }
            }
            totalCount
        }
    }
`);

export const GET_MITIGATED_NOTIFICATIONS_FOR_COMPONENT = graphql(`
    extend type ProjectComponentNotification
        @typePolicy(keyFields: "assetItemID notificationID componentID")
    query GetMitigatedNotificationsForComponent($pid: ID!, $componentId: ID!) {
        projectComponentsNotifications(
            projectID: $pid
            where: { componentID: $componentId, mitigationIDNotNil: true }
            first: 100
        ) {
            edges {
                node {
                    assetItemID
                    componentID
                    notificationID
                }
            }
        }
    }
`);

export const GET_UNRESOLVED_NOTIFICATIONS_BY_ZONE = graphql(`
    extend type ProjectComponentNotification
        @typePolicy(keyFields: "assetItemID notificationID componentID")
    query GetUnresolvedNotificationsByZone(
        $pid: ID!
        $zoneID: ID!
        $first: Int
    ) {
        projectComponentsNotifications(
            projectID: $pid
            where: {
                projectZoneID: $zoneID
                and: [
                    {
                        or: [
                            { mitigationIDIsNil: true }
                            {
                                mitigationIDIsNil: false
                                mitigationStatusNotIn: ["COMPLETED", "OBSOLETE"]
                            }
                        ]
                    }
                    { assetStatusNotIn: ["INVALID"] }
                ]
            }
            first: $first
        ) {
            edges {
                node {
                    assetItemID
                    componentID
                    projectZoneID
                    notificationID
                    mitigationStatus
                }
            }
            totalCount
        }
    }
`);

// Default value for first parameter
export const UNRESOLVED_NOTIFICATIONS_FIRST_DEFAULT = 100;

export const GET_MEASURES_FOR_PROJECT = graphql(`
    query getMeasuresForProject($pid: ID!) {
        measures(where: { projectID: $pid }) {
            edges {
                node {
                    id
                    createTime
                    updateTime
                    name
                    type
                    howto
                    resources
                    justification
                    updateToComponent {
                        id
                        name
                        componentVendor {
                            id
                            name
                        }
                        version
                    }
                    mitigations {
                        id
                    }
                }
            }
            totalCount
        }
    }
`);

export const GET_MITIGATIONS = graphql(`
    query getMitigations($input: MitigationWhereInput!) {
        mitigations(where: $input) {
            edges {
                node {
                    ...MitigationFragment
                }
            }
            totalCount
        }
    }
`);

export const GET_MEASURES_EXISTENCE = graphql(`
    query getMeasuresExistence($where: MeasureWhereInput!) {
        measures(where: $where, first: 1) {
            edges {
                node {
                    id
                }
            }
        }
    }
`);

export const GET_MEASURES_COUNT = graphql(`
    query getMeasuresCount($where: MeasureWhereInput!) {
        measures(where: $where, first: 0) {
            totalCount
        }
    }
`);
